import React, { useState, useEffect } from "react";
import WebRoutes from "./Routes/WebRoutes";
import { useDispatch } from "react-redux";
import { userActions } from "./_actions";
import { userService } from "./_services";
import { userConstants } from "./_constants";

export default function App() {
  const dispatch = useDispatch();
  
  // Check for authentication data from URL parameters (cross-domain redirect)
  const urlParams = new URLSearchParams(window.location.search);
  const urlToken = urlParams.get('token');
  const urlUserId = urlParams.get('userId');
  const urlEmail = urlParams.get('email');
  
 
  const [isValidating, setIsValidating] = useState(true);
  const [urlParamsProcessed, setUrlParamsProcessed] = useState(false);

  // Process URL parameters first
  useEffect(() => {
    if (urlToken && urlUserId && urlEmail && !urlParamsProcessed) {
      console.log('Setting authentication data from URL parameters');
      localStorage.setItem('userToken', urlToken);
      localStorage.setItem('id', urlUserId);
      localStorage.setItem('email', urlEmail);
      localStorage.setItem('is_login', 'true');
      
      // Also set a basic user object for immediate use
      const basicUser = {
        sucess: true,
        success: true,
        token: urlToken,
        data: {
          id: urlUserId,
          email: urlEmail
        }
      };
      localStorage.setItem('user', JSON.stringify(basicUser));
      
      // Dispatch login success to update Redux state immediately
      dispatch({ type: userConstants.LOGIN_SUCCESS, user: basicUser });
      
      // Clean the URL by removing the parameters
      const cleanUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, cleanUrl);
      
      setUrlParamsProcessed(true);
    }
  }, [urlToken, urlUserId, urlEmail, urlParamsProcessed, dispatch]);

  useEffect(() => {
    const validateSession = async () => {
      const currentToken = userService.getAuthToken();
      
      if (!currentToken) {
        // Check if there's user data from redirect (without token validation)
        const userData = localStorage.getItem("user");
        if (userData) {
          console.log('Found user data from redirect:', userData);
        }
        setIsValidating(false);
        return;
      }
      console.log('authToken', currentToken);

      try 
      {
        const result = await dispatch(userActions.userSession({ token: currentToken }));
        if (!result?.sucess && !result?.success) {
          // Clear all data if session is invalid
          localStorage.removeItem("id");
          localStorage.removeItem("email");
          localStorage.removeItem("is_login");
          localStorage.removeItem("user_pro");
          localStorage.removeItem("userToken");
          document.cookie = `authToken=; path=/; domain=${process.env.REACT_APP_SUB_DOMAIN}; expires=Thu, 01 Jan 1970 00:00:01 UTC; secure; SameSite=None`;
        }
      } catch (error) {
        // Clear all data on error
        localStorage.removeItem("id");
        localStorage.removeItem("email");
        localStorage.removeItem("is_login");
        localStorage.removeItem("user_pro");
        localStorage.removeItem("userToken");
        document.cookie = `authToken=; path=/; domain=${process.env.REACT_APP_SUB_DOMAIN}; expires=Thu, 01 Jan 1970 00:00:01 UTC; secure; SameSite=None`;
      } finally {
        setIsValidating(false);
      }
    };

    validateSession();
  }, [urlParamsProcessed, dispatch]);

  if (isValidating) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  return <WebRoutes />;
}